import React from 'react';

const CTWrapper = ({ children, className }) => {
  return <div className={`mx-auto w-full max-w-[1320px] px-5 md:px-10 ${className || ''}`}>{children}</div>;
};

export default CTWrapper;
